import { render } from "./ViewMailChannel.vue?vue&type=template&id=21a796bc"
import script from "./ViewMailChannel.vue?vue&type=script&lang=js"
export * from "./ViewMailChannel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__